import { useIM, GroupStatusEvent } from '@wui/im'
import { defineStore } from 'pinia'
import { ref } from 'vue'

import { ContactStatuses } from '@/shared/contact-status/types'
import { isGuest } from '@/shared/utils/uri'

export const useStoreGuestStatus = defineStore('guest-status', () => {
  const statuses = ref(new Map<string, ContactStatuses>())

  const { onConferenceUpdated } = useIM()
  onConferenceUpdated((event: GroupStatusEvent) => {
    const { pServed } = event
    if (!isGuest(pServed)) {
      return
    }

    statuses.value.set(pServed, {
      isOnline: event.isOnline,
      lastSeen: event.lastSeen,
      status: event.status,
      statusMessage: event.message,
    })
  })

  const getStatusByPServed = (pServed: string): ContactStatuses | undefined => {
    return statuses.value.get(pServed)
  }

  return {
    getStatusByPServed,
  }
})
